import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AnnualPlanWindow from './view/annual-plan-window';

const AnnualPlanWindowRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AnnualPlanWindow />} />
  </ErrorBoundaryRoutes>
);

export default AnnualPlanWindowRoutes;
